/* MONDSTEIN by Metagon · mds-video.js · section mds-video. Click facade: before the click only the poster exists (no
   YouTube/Vimeo request, no cookie). "abspielen" swaps in the player: youtube-nocookie.com or player.vimeo.com in an
   iframe, or the Shopify <video> kept in a <template>. Chapter buttons ([data-t], seconds) start the video there.
   A page URL with ?t=<seconds> (the chapter URLs in the VideoObject JSON-LD) starts there on the first click. */
import { $$, boot, claim } from '@mds/core';

const startParam = Math.max(0, parseInt(new URLSearchParams(location.search).get('t') || '0', 10) || 0);

function play(box, t) {
  const frame = box.querySelector('.vid-frame');
  if (!frame) return;
  const start = Math.max(0, Math.floor(t || 0));
  const yt = box.dataset.yt, vimeo = box.dataset.vimeo;
  if (yt || vimeo) {
    const src = yt
      ? 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(yt) + '?autoplay=1&rel=0&playsinline=1&start=' + start
      : 'https://player.vimeo.com/video/' + encodeURIComponent(vimeo) + '?autoplay=1&dnt=1#t=' + start + 's';
    let f = frame.querySelector('iframe');
    if (!f) {
      f = document.createElement('iframe');
      f.title = box.dataset.title || '';
      f.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
      f.allowFullscreen = true;
      frame.replaceChildren(f);
    }
    f.src = src;
    f.focus();
  } else {
    let v = frame.querySelector('video');
    if (!v) {
      const tpl = frame.querySelector('template[data-mds-video-tpl]');
      if (!tpl) return;
      frame.replaceChildren(tpl.content.cloneNode(true));
      v = frame.querySelector('video');
      if (!v) return;
    }
    const seek = () => { v.currentTime = start; };
    if (v.readyState >= 1) seek(); else v.addEventListener('loadedmetadata', seek, { once: true });
    const p = v.play();
    if (p && p.catch) p.catch(() => {});
    v.focus();
  }
  box.classList.add('is-playing');
}

function init(root) {
  $$('[data-mds-video]', root).forEach((box) => {
    if (!claim(box, 'Video')) return;
    const sec = box.closest('section') || box;
    const btn = box.querySelector('[data-mds-video-play]');
    if (btn) btn.addEventListener('click', () => play(box, startParam));
    $$('[data-t]', sec).forEach((c) => c.addEventListener('click', () => {
      play(box, +c.dataset.t);
      box.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }));
  });
}

boot(init);
